import { Card, Row, Col } from 'react-bootstrap';
import "./Invoice.scss"

interface propData {
    data: any
}

const InvoiceDetailRecommendation = (props: propData) => {
    return (
        <>
            <Card className="card-style form-style" style={{ marginBottom: 50 }}>
                <div className='mt-2 mb-2'>
                    <div className="mb-0 font-w-medium font-15 ms-2">Description:</div>
                    {
                        props?.data?.recommendations && props?.data?.recommendations.length > 0 && props?.data?.recommendations.map((res: any, index: any) => {
                            return (
                                <div className='p-2'>
                                    <div className='recommendation-box'>{index + 1 } ) {res}</div>
                                </div>
                            )
                        })
                    }
                </div>
            </Card>
        </>
    )
}

export default InvoiceDetailRecommendation;